// Can use png, svg, webp, etc.
//
import demdemo from 'assets/logos/demdemo.svg';

import breaktime from 'assets/logos/breaktime.png';
import puretech from 'assets/logos/puretech.png';
import accessfinance from 'assets/logos/accessfinance.png';
import cxg from 'assets/logos/cxg.jpg';
import ebury from 'assets/logos/ebury.png';
import goodmorning from 'assets/logos/goodmorning.svg';
import ibanfirst from 'assets/logos/ibanfirst.png';
import kinetik from 'assets/logos/kinetik.webp';
import pharmbills from 'assets/logos/pharmbills.svg';

import worknomads from 'assets/logos/worknomads.webp';
import vivacredit from 'assets/logos/vivacredit.svg';
import stp from 'assets/logos/stp.png';
import looming from 'assets/logos/looming.png';
import novatel from 'assets/logos/novatel.png';
import southgate from 'assets/logos/southgate.png';
import str from 'assets/logos/str.png';
import pi2pr from 'assets/logos/pi2pr.webp';
import akpz from 'assets/logos/akpz.webp';
import st6 from 'assets/logos/st6.webp';
import socyber from 'assets/logos/socyber.png';
import itspecials from 'assets/logos/itspecials.svg';
import apexhc from 'assets/logos/apexhc.webp';
import igaming from 'assets/logos/igaming.svg';
import neoperl from 'assets/logos/neoperl.svg';
import mediapost from 'assets/logos/mediapost.png';
import oneforfit from 'assets/logos/1forfit.jpg';
import metrica from 'assets/logos/metrica.png';
import inaessentials from 'assets/logos/inaessentials.jpg';
import kikimora from 'assets/logos/kikimora.png';
import flutter from 'assets/logos/flutter.png';
import commerzbank from 'assets/logos/commerzbank.svg';
import pelintex from 'assets/logos/pelintex.svg';
import clientx from 'assets/logos/clientx.png';
import vedaaccounting from 'assets/logos/vedaaccounting.svg';
// EIH
import alg from 'assets/logos/alg.png';
import apolo from 'assets/logos/apolo.png';
import bmmg from 'assets/logos/bmmg.png';
import orient from 'assets/logos/orient.png';
import eih from 'assets/logos/eih.png';
// EIH
import skillwork from 'assets/logos/skillwork.png';
import fintrade from 'assets/logos/fintrade.svg';
import omegacoders from 'assets/logos/omegacoders.webp';

import hacksoft from 'assets/logos/hacksoft.svg';
import intellicsengineering from 'assets/logos/intellicsengineering.png';
import wiara from 'assets/logos/wiara.svg';
import easycredit from 'assets/logos/easycredit.svg';
import globawise from 'assets/logos/globawise.png';
import mtsglobe from 'assets/logos/mtsglobe.png';
import foundrg from 'assets/logos/foundrg.png';
import stanvision from 'assets/logos/stanvision.svg';
import rsm from 'assets/logos/rsm.svg';

import teamgpt from 'assets/logos/teamgpt.png';
import meavo from 'assets/logos/meavo.webp';
import finrax from 'assets/logos/finrax.png';
import rexera from 'assets/logos/rexera.svg';
import ecopack from 'assets/logos/ecopack.png';
import sallina from 'assets/logos/sallina7.png';
import emsagrup from 'assets/logos/emsagrup.png';

import advertising411 from 'assets/logos/411advertising.jpg';
import marketing411 from 'assets/logos/411marketing.jpg';
import financialpartners from 'assets/logos/financialpartners.png';
import bposs from 'assets/logos/bposs.png';

import liveinteractive from 'assets/logos/liveinteractive.png';
import robertshaw from 'assets/logos/robertshaw.svg';
import tombou from 'assets/logos/tombou.png';
import rmh from 'assets/logos/rmh.png';

import bigarena from 'assets/logos/bigarena.svg';

import lendivo from 'assets/logos/lendivo.svg';
import stikcredit from 'assets/logos/stikcredit.svg';
import tiberus from 'assets/logos/tiberus.png';

import bluewindow from 'assets/logos/bluewindow.jpg';

import intway from 'assets/logos/intway.png';
import teamcodery from 'assets/logos/teamcodery.svg';
import mambaplay from 'assets/logos/mambaplay.svg';

import elvada from 'assets/logos/elvada.png';
import juma from 'assets/logos/juma.png';

import fontfabric from 'assets/logos/fontfabric.svg';
import quehenberger from 'assets/logos/quehenberger.svg';
import abrites from 'assets/logos/abrites.png';
import concordia from 'assets/logos/concordia.png';

import emiroglio from 'assets/logos/emiroglio.jpg';
import eltrak from 'assets/logos/eltrak.svg';
import maximabulgaria from 'assets/logos/maxima.bulgaria.png';

import elfshock from 'assets/logos/elfshock.png';
import lacrima from 'assets/logos/lacrima.webp';
import seewines from 'assets/logos/seewines.svg';
import centricsoft from 'assets/logos/centricsoft.svg';

import isbg from 'assets/logos/isbg.png';
import postworks from 'assets/logos/postworks.svg';
import ototon from 'assets/logos/ototon.png';

import tridilabs from 'assets/logos/tridilabs.png';
import zaednovchas from 'assets/logos/zaednovchas.svg';

import camco from 'assets/logos/camco.png';
import mozarto from 'assets/logos/mozarto.svg';

interface TenantConfig {
  logoFile: any;
  showInsteadOfOriginalLogo: boolean;
}

interface TenantConfigMap {
  [key: string]: TenantConfig;
}

const tenantLogoConfig: TenantConfigMap = {
  tenant1: {
    logoFile: demdemo,
    showInsteadOfOriginalLogo: true,
  },
  tenant2: {
    logoFile: demdemo,
    showInsteadOfOriginalLogo: false,
  },
  demdemo: {
    logoFile: demdemo,
    showInsteadOfOriginalLogo: false,
  },
  breaktime: {
    logoFile: breaktime,
    showInsteadOfOriginalLogo: false,
  },
  puretech: {
    logoFile: puretech,
    showInsteadOfOriginalLogo: false,
  },
  worknomads: {
    logoFile: worknomads,
    showInsteadOfOriginalLogo: false,
  },
  vivacredit: {
    logoFile: vivacredit,
    showInsteadOfOriginalLogo: false,
  },
  stp: {
    logoFile: stp,
    showInsteadOfOriginalLogo: false,
  },
  looming: {
    logoFile: looming,
    showInsteadOfOriginalLogo: false,
  },
  novatel: {
    logoFile: novatel,
    showInsteadOfOriginalLogo: false,
  },
  southgate: {
    logoFile: southgate,
    showInsteadOfOriginalLogo: false,
  },
  str: {
    logoFile: str,
    showInsteadOfOriginalLogo: false,
  },
  pi2pr: {
    logoFile: pi2pr,
    showInsteadOfOriginalLogo: false,
  },
  akpz: {
    logoFile: akpz,
    showInsteadOfOriginalLogo: false,
  },
  st6: {
    logoFile: st6,
    showInsteadOfOriginalLogo: false,
  },
  socyber: {
    logoFile: socyber,
    showInsteadOfOriginalLogo: false,
  },
  'it-specials': {
    logoFile: itspecials,
    showInsteadOfOriginalLogo: false,
  },
  apexhc: {
    logoFile: apexhc,
    showInsteadOfOriginalLogo: false,
  },
  kinetik: {
    logoFile: kinetik,
    showInsteadOfOriginalLogo: false,
  },
  goodmorning: {
    logoFile: goodmorning,
    showInsteadOfOriginalLogo: false,
  },
  ibanfirst: {
    logoFile: ibanfirst,
    showInsteadOfOriginalLogo: false,
  },
  ebury: {
    logoFile: ebury,
    showInsteadOfOriginalLogo: false,
  },
  pharmbills: {
    logoFile: pharmbills,
    showInsteadOfOriginalLogo: false,
  },
  accessfinance: {
    logoFile: accessfinance,
    showInsteadOfOriginalLogo: false,
  },
  cxg: {
    logoFile: cxg,
    showInsteadOfOriginalLogo: false,
  },
  neoperl: {
    logoFile: neoperl,
    showInsteadOfOriginalLogo: false,
  },
  'igaming-demo': {
    logoFile: igaming,
    showInsteadOfOriginalLogo: false,
  },
  mediapost: {
    logoFile: mediapost,
    showInsteadOfOriginalLogo: false,
  },
  '1forfit': {
    logoFile: oneforfit,
    showInsteadOfOriginalLogo: false,
  },
  metrica: {
    logoFile: metrica,
    showInsteadOfOriginalLogo: false,
  },
  inaessentials: {
    logoFile: inaessentials,
    showInsteadOfOriginalLogo: false,
  },
  kikimora: {
    logoFile: kikimora,
    showInsteadOfOriginalLogo: false,
  },
  'flutter-demo': {
    logoFile: flutter,
    showInsteadOfOriginalLogo: false,
  },
  commerzbank: {
    logoFile: commerzbank,
    showInsteadOfOriginalLogo: false,
  },
  clientx: {
    logoFile: clientx,
    showInsteadOfOriginalLogo: false,
  },
  pelintex: {
    logoFile: pelintex,
    showInsteadOfOriginalLogo: false,
  },
  'veda-accounting': {
    logoFile: vedaaccounting,
    showInsteadOfOriginalLogo: false,
  },
  alg: {
    logoFile: alg,
    showInsteadOfOriginalLogo: false,
  },
  apolo: {
    logoFile: apolo,
    showInsteadOfOriginalLogo: false,
  },
  bmmg: {
    logoFile: bmmg,
    showInsteadOfOriginalLogo: false,
  },
  orient: {
    logoFile: orient,
    showInsteadOfOriginalLogo: false,
  },
  eih: {
    logoFile: eih,
    showInsteadOfOriginalLogo: false,
  },
  skillwork: {
    logoFile: skillwork,
    showInsteadOfOriginalLogo: false,
  },
  fintrade: {
    logoFile: fintrade,
    showInsteadOfOriginalLogo: false,
  },
  omegacoders: {
    logoFile: omegacoders,
    showInsteadOfOriginalLogo: false,
  },
  hacksoft: {
    logoFile: hacksoft,
    showInsteadOfOriginalLogo: false,
  },
  intellicsengineering: {
    logoFile: intellicsengineering,
    showInsteadOfOriginalLogo: false,
  },
  wiara: {
    logoFile: wiara,
    showInsteadOfOriginalLogo: false,
  },
  'easycredit-demo': {
    logoFile: easycredit,
    showInsteadOfOriginalLogo: false,
  },
  globawise: {
    logoFile: globawise,
    showInsteadOfOriginalLogo: true,
  },
  'found-rg': {
    logoFile: foundrg,
    showInsteadOfOriginalLogo: false,
  },
  mtsglobe: {
    logoFile: mtsglobe,
    showInsteadOfOriginalLogo: false,
  },
  stanvision: {
    logoFile: stanvision,
    showInsteadOfOriginalLogo: false,
  },
  rsm: {
    logoFile: rsm,
    showInsteadOfOriginalLogo: false,
  },
  'team-gpt': {
    logoFile: teamgpt,
    showInsteadOfOriginalLogo: false,
  },
  'office-acoustics': {
    logoFile: meavo,
    showInsteadOfOriginalLogo: false,
  },
  finrax: {
    logoFile: finrax,
    showInsteadOfOriginalLogo: false,
  },
  rexera: {
    logoFile: rexera,
    showInsteadOfOriginalLogo: false,
  },
  ecopack: {
    logoFile: ecopack,
    showInsteadOfOriginalLogo: false,
  },
  sallina7: {
    logoFile: sallina,
    showInsteadOfOriginalLogo: false,
  },
  emsagrup: {
    logoFile: emsagrup,
    showInsteadOfOriginalLogo: false,
  },
  flutter: {
    logoFile: flutter,
    showInsteadOfOriginalLogo: false,
  },
  easycredit: {
    logoFile: easycredit,
    showInsteadOfOriginalLogo: false,
  },
  'bpo-software': {
    logoFile: bposs,
    showInsteadOfOriginalLogo: false,
  },
  'financial-partners': {
    logoFile: financialpartners,
    showInsteadOfOriginalLogo: false,
  },
  '411marketing': {
    logoFile: marketing411,
    showInsteadOfOriginalLogo: false,
  },
  '411advertising': {
    logoFile: advertising411,
    showInsteadOfOriginalLogo: false,
  },
  robertshaw: {
    logoFile: robertshaw,
    showInsteadOfOriginalLogo: false,
  },
  liveinteractive: {
    logoFile: liveinteractive,
    showInsteadOfOriginalLogo: false,
  },
  tombou: {
    logoFile: tombou,
    showInsteadOfOriginalLogo: false,
  },
  rmh: {
    logoFile: rmh,
    showInsteadOfOriginalLogo: false,
  },
  bigarena: {
    logoFile: bigarena,
    showInsteadOfOriginalLogo: false,
  },
  lendivo: {
    logoFile: lendivo,
    showInsteadOfOriginalLogo: false,
  },
  stikcredit: {
    logoFile: stikcredit,
    showInsteadOfOriginalLogo: false,
  },
  tiberus: {
    logoFile: tiberus,
    showInsteadOfOriginalLogo: false,
  },
  bluewindow: {
    logoFile: bluewindow,
    showInsteadOfOriginalLogo: false,
  },
  intway: {
    logoFile: intway,
    showInsteadOfOriginalLogo: false,
  },
  teamcodery: {
    logoFile: teamcodery,
    showInsteadOfOriginalLogo: false,
  },
  mambaplay: {
    logoFile: mambaplay,
    showInsteadOfOriginalLogo: false,
  },
  elvada: {
    logoFile: elvada,
    showInsteadOfOriginalLogo: false,
  },
  'emiroglio-demo': {
    logoFile: emiroglio,
    showInsteadOfOriginalLogo: false,
  },
  juma: {
    logoFile: juma,
    showInsteadOfOriginalLogo: false,
  },
  fontfabric: {
    logoFile: fontfabric,
    showInsteadOfOriginalLogo: false,
  },
  quehenberger: {
    logoFile: quehenberger,
    showInsteadOfOriginalLogo: false,
  },
  abrites: {
    logoFile: abrites,
    showInsteadOfOriginalLogo: false,
  },
  concordia: {
    logoFile: concordia,
    showInsteadOfOriginalLogo: false,
  },
  emiroglio: {
    logoFile: emiroglio,
    showInsteadOfOriginalLogo: false,
  },
  demodemo2: {
    logoFile: eltrak,
    showInsteadOfOriginalLogo: false,
  },
  'maximabulgaria-demo': {
    logoFile: maximabulgaria,
    showInsteadOfOriginalLogo: false,
  },
  elfshock: {
    logoFile: elfshock,
    showInsteadOfOriginalLogo: false,
  },
  centricsoft: {
    logoFile: centricsoft,
    showInsteadOfOriginalLogo: false,
  },
  lacrima: {
    logoFile: lacrima,
    showInsteadOfOriginalLogo: false,
  },
  seewines: {
    logoFile: seewines,
    showInsteadOfOriginalLogo: false,
  },
  'is-demo-3151': {
    logoFile: isbg,
    showInsteadOfOriginalLogo: false,
  },
  postworks: {
    logoFile: postworks,
    showInsteadOfOriginalLogo: false,
  },
  ototon: {
    logoFile: ototon,
    showInsteadOfOriginalLogo: false,
  },
  tridilabs: {
    logoFile: tridilabs,
    showInsteadOfOriginalLogo: false,
  },
  zaednovchas: {
    logoFile: zaednovchas,
    showInsteadOfOriginalLogo: false,
  },
  mozarto: {
    logoFile: mozarto,
    showInsteadOfOriginalLogo: false,
  },
  camco: {
    logoFile: camco,
    showInsteadOfOriginalLogo: false,
  },
};

export default tenantLogoConfig;
